'use es6';

export default {
  ALL: 'ALL'
};